/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import HairlineDivider from '@tds/core-hairline-divider';

import Modal from '../design/shared/modal';
import { Box } from '../design/css';
import { Heading, Text, customStyles } from './css';
import {
  OrderSummaryModel,
  OptOrderSummaryModel,
  SalesOrderCheckListPageModel,
  HsiaQualificationsPageModel,
  ChannelRepModel,
  AdministratorContactModel,
  CustomerBillingAddressModel,
  OnSiteDetailsModel,
  ProductSelectionModel,
  CustomerShippingAddressModel,
  EmergencyContactModel,
  SigningAuthorityModel,
  OrderCommentsModel,
  EmergencyContact2Model,
  EmergencyContact3Model,
  StatusUpdateModel,
  CustomerInformationModel,
  CopperInternetModel,
  FibreInternetModel,
  BusinessWiFiModel,
  OfficePhoneModel,
  TelusOptikTvModel
} from './models';
import UpdateOrder from './updateOrder';
import { isEmpty } from '../utils/utils';

const OPT_ORDER = 'optOrder';
const WIRELINE = 'wireline';

const OrderDetails = ({
  open,
  setOpen,
  order,
  labels,
  onSave,
  staticLabels,
  users
}) => {
  const isOptOrder = order.s1_order_for === OPT_ORDER;
  const isWlnOrder = order.s1_order_for === WIRELINE;
  const {
    ORDER_SUMMARY,
    FORM_SUMMARY,
    FORM_COMMENTS,
    SALES_ORDER_CHECKLIST,
    HSIA_QUALIFICATION,
    SALES_CHANNEL_REP,
    ADMINISTRATOR_CONTACT,
    CUSTOMER_INFORMATION,
    CUSTOMER_SHIPPING_ADDRESS,
    CUSTOMER_BILLING_ADDRESS,
    EMERGENCY_CONTACTS_1,
    EMERGENCY_CONTACTS_2,
    EMERGENCY_CONTACTS_3,
    SIGNING_AUTHORITY,
    ON_SITE_CONTACT_DETAILS,
    PRODUCT_SELECTION_PAGE,
    COPPER_INTERNET,
    FIBRE_INTERNET,
    BUSINESS_WIFI,
    OFFICE_PHONE,
    TELUS_OPTIK_TV,
    ORDER_COMMENTS,
    ORDER_DETAILS,
    STATUS_UPDATES
  } = staticLabels;
  const sectionMapping = {
    [ORDER_SUMMARY]: new OrderSummaryModel(order),
    [SALES_ORDER_CHECKLIST]: new SalesOrderCheckListPageModel(order),
    [HSIA_QUALIFICATION]: new HsiaQualificationsPageModel(order),
    [SALES_CHANNEL_REP]: new ChannelRepModel(order),
    [ADMINISTRATOR_CONTACT]: new AdministratorContactModel(order),
    [CUSTOMER_INFORMATION]: new CustomerInformationModel(order),
    [CUSTOMER_SHIPPING_ADDRESS]: new CustomerShippingAddressModel(order),
    [CUSTOMER_BILLING_ADDRESS]: new CustomerBillingAddressModel(order),
    [EMERGENCY_CONTACTS_1]: new EmergencyContactModel(order),
    [EMERGENCY_CONTACTS_2]: new EmergencyContact2Model(order),
    [EMERGENCY_CONTACTS_3]: new EmergencyContact3Model(order),
    [SIGNING_AUTHORITY]: new SigningAuthorityModel(order),
    [ON_SITE_CONTACT_DETAILS]: new OnSiteDetailsModel(order),
    [PRODUCT_SELECTION_PAGE]: new ProductSelectionModel(order, labels),
    [COPPER_INTERNET]: new CopperInternetModel(order),
    [FIBRE_INTERNET]: new FibreInternetModel(order),
    [BUSINESS_WIFI]: new BusinessWiFiModel(order),
    [OFFICE_PHONE]: isWlnOrder && new OfficePhoneModel(order),
    [TELUS_OPTIK_TV]: new TelusOptikTvModel(order),
    [ORDER_COMMENTS]: new OrderCommentsModel(order),
    [STATUS_UPDATES]: new StatusUpdateModel(order)
  };
  const optSectionMapping = {
    [FORM_SUMMARY]: new OptOrderSummaryModel(order),
    [FORM_COMMENTS]: new OrderCommentsModel(order)
  };
  const mapping = isOptOrder ? optSectionMapping : sectionMapping;
  const detailSection = (header, details) => {
    const showDetails = !Object.values(details).every(isEmpty);

    return (
      showDetails && (
        <Box>
          <Heading>{header}</Heading>
          <Box>
            {Object.keys(details).map(cell => {
              const label =
                labels[cell] ||
                (localStorage.getItem('locale') === 'FR'
                  ? 'Étiquette à ajouter'
                  : 'Label To be Added');

              return (
                !!details[cell] && (
                  <Box>
                    <Text bold>{`${label}: `}</Text>
                    <Text>{details[cell]}</Text>
                  </Box>
                )
              );
            })}
            <Box pt={16} pb={16}>
              <HairlineDivider gradient />
            </Box>
          </Box>
        </Box>
      )
    );
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      order={order}
      header={ORDER_DETAILS}
      customStyles={customStyles}
    >
      <UpdateOrder
        order={order}
        setOpen={setOpen}
        open={open}
        onSave={onSave}
        users={users}
        assignedUserId={order.assigned_user_id}
        isOptOrder={isOptOrder}
        staticLabels={staticLabels}
      >
        {order &&
          Object.keys(mapping).map(section =>
            detailSection(section, mapping[section])
          )}
      </UpdateOrder>
    </Modal>
  );
};

OrderDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  staticLabels: PropTypes.object.isRequired
};
export default OrderDetails;
